import CaracteristiquesController from './caracteristiques.controller';

export default {
    template: require('./caracteristiques.tpl.html'),
    controller: CaracteristiquesController
};
